var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseGridLayout',{staticClass:"st-container mx-auto",attrs:{"id":_vm.anchorName,"size":"small"}},_vm._l((_vm.getContent),function(section){return _c('div',{key:section.id,staticClass:"grid empty:hidden",class:_vm.colSpan[_vm.numberOfColumns]},[_c('FSXARenderContentElement',{attrs:{"element":section}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }